export default "__VITE_ASSET__DIwng0pB__"